import type { CrmCategoryRef } from '../types'
import type { LabelLike } from '../components/LabelChip'
import type { ExistingMode, ImportMode, ImportSettingsPayload } from './types'

/** What the user sets once for the whole file. */
export interface ImportSettings {
  category: CrmCategoryRef | null
  labels: LabelLike[]
  ownerId: string
  existing: ExistingMode
  note: string
  /** spec-63 E5: every contact of the import goes onto this static list (contacts only). The name is '' until the lists are loaded. */
  list: { id: string; name: string } | null
}

export function emptySettings(): ImportSettings {
  return { category: null, labels: [], ownerId: '', existing: 'aanvullen', note: '', list: null }
}

/** The settings as the API takes them; the note is for new contacts only. */
export function settingsPayload(settings: ImportSettings, mode: ImportMode): ImportSettingsPayload {
  return {
    category_id: settings.category?.id ?? null,
    label_ids: settings.labels.map((label) => label.id),
    owner_id: settings.ownerId || null,
    existing: settings.existing,
    note: mode === 'contacten' ? settings.note.trim() || null : null,
    ...(mode === 'contacten' && settings.list ? { list_id: settings.list.id } : {}),
  }
}
